import { autoinject } from "aurelia-framework";
import { DialogController } from 'aurelia-dialog';
import { SessionData } from '_models/session-data';
import * as Dto from '_models/dtos';
import { SortService } from '_services/sort-service';

@autoinject
export class LocationProductsDialog {

    constructor(
        public controller: DialogController,
        public sd: SessionData) {

        this.products = [];
    }

    /**
      * The location that products will be added to.
      */
    location: Dto.ScheduledLocationProjection;

    /**
      * A list of all user selected products to choose from.
      */
    products: any[];


    productSorter = new SortService('colorNumber', 'asc');

    sortProducts(propertyName: string) {
        this.productSorter.sort(this.sd.allSelectedProducts, propertyName);
    }


    activate(location: Dto.ScheduledLocationProjection) {
        
        this.location = location;

        // Populate selectable products from the list of user selected products in the session
        this.products = this.sd.allSelectedProducts
            .map(p => {
                var selectableProduct = p as any;
                // Append 'isSelected' property
                selectableProduct.isSelected = false;
                return selectableProduct;
            });
    }
        
    addProducts() {

        // Return selected products array
        var selectedProducts = this.products
            .filter(p => p.isSelected)
            .map(p => p as Dto.WizardProductColorSelection);

        this.controller.ok(selectedProducts);
    }

    cancel() {
        this.controller.cancel()
    }
}

//class SelectableItem<TItem> {
//    constructor(item: TItem) {
//        this.item = item;
//    }

//    item: TItem;
//    isSelected: boolean;
//}
